import { ENVIRONMENTS } from '../../../../../common/config/env';
import koganAPI from '../../../apis/kogan-api';
import s3API from '../../../apis/s3-api';
import env from '../../../../../common/config/env';
import axios from 'axios';
import { Auth } from 'aws-amplify';
export const uploadImageToS3= async (file,onUploadProgress)=>{
  
    /*following code required to make it work in dev with proxy to bypass CORS issue*/
    const INSTANCE = await getEnvSpecificAxiosInstance(file,onUploadProgress);
    const response= await INSTANCE.AXIOS.put(INSTANCE.URL,file,INSTANCE.config);
    return response;
}

export const deleteImageFromS3=async (file)=>{
    const INSTANCE = await getEnvSpecificAxiosInstance(file);
    return await INSTANCE.AXIOS.delete(INSTANCE.URL,INSTANCE.config);
}

export const listImages=(sku)=>{
    return koganAPI.get(`products/${sku}/images`);
}


const getEnvSpecificAxiosInstance= async (file,onUploadProgress)=>{
    let axiosInstance = s3API;
    let url=`products/${file.folder}/images/${file.name}`;
    
    const config = {
        headers:{
            'Content-Type':file.type
        },
        onUploadProgress
    };

    if(env.name===ENVIRONMENTS.DEVELOPMENT.name){
        axiosInstance = axios;
        url=`/v1/koganapi/${url}`;
        //manually add auth token here as as are bypassing interceptor
        config.headers.Authorization=`Bearer ${(await Auth.currentSession()).getIdToken()?.getJwtToken()}`;
        
    }
    return {
        AXIOS: axiosInstance,
        URL: url,
        config
    };
}